<template>
	<!-- Modal -->
	<form class="modal fade" id="modal-add-rate" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" @submit="addRate">
	  <div class="modal-dialog" role="document">
	    <div class="modal-content">
	      <div class="modal-header no-padding-bottom">
	        <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
	        <h2 class="text-uppercase no-margin">Calificación</h2>
	      </div>
	      <div class="modal-body no-padding-top">
	      	
				  <div class="form-group">
				    <p><strong>Calificación</strong></p>
			      <input type="hidden" class="modal rating" data-filled="fa fa-star item-rate-yellow item-rate" data-empty="fa fa-star item-rate-gray item-rate" data-fractions="2.5" v-model="form.rating"/>
				  </div>
				  <div class="form-group">
				    <label for="title">Título de la reseña:</label>
				    <input type="text" class="form-control" id="reseña" placeholder="Escribe el título de tu reseña" v-model="form.title">
				  </div>
				  <div class="form-group">
				    <label for="comment">Reseña:</label>
				    <textarea class="form-control" name="comment" id="comment" cols="30" rows="10" placeholder="Escribe tu reseña" v-model="form.review"></textarea>
				  </div>
	      	
	      </div>
	      <div class="modal-footer">
	        <input type="submit" class="btn btn-black" value="Enviar calificación"/>
	      </div>
	    </div>
	  </div>
	</form>
</template>

<style scoped>
	.btn-link {
		color: black;
	}
</style>

<script>
import Stars from '../Product/Product-detail-rate-stars.vue';
import { addRating } from '../../store/actions';

const form = {
	rating: null,
	title: null,
	review: null
}

export default {
	data () {
		return {
			form: form
		}
	},

	vuex: {
		getters: {
			user: state => state.current_user,
			product: state => state.current_product
		},
		actions: {
			addRating
		}
	},

	methods: {
		addRate (e) {
			e.preventDefault();

			this.form.product_id = this.product.id;
			this.addRating(this.user, this.form);
			
			$('.modal.rating').rating('rate', 0);
			
			this.resetForm();
			// e.target.reset();
		},

		resetForm () {
			for (let k in this.form) {
				this.form[k] = null;
			}
		},

		showModalByQuery () {
			let user = JSON.parse(localStorage.getItem('lasddi')) || {};
			if (this.$route.query.modal && user.token) {
				return $('#modal-add-rate').modal('show');
			}

			// if (this.$route.query.modal && !user.token) {
			// 	return this.$route.router.go(`/login?redirect=${encodeURIComponent(this.$route.path)}`);
			// }
		}
	},

	ready () {
		$('.rating').rating();
		this.showModalByQuery();
	},

	components: {
		Stars
	}
}
</script>


// WEBPACK FOOTER //
// Modal-add-rate.vue?32499209